import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "d-flex flex-wrap" }
const _hoisted_4 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_5 = { align: "center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_7 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  YOUR PERSONAL ACCUMULATED PV", -1)
const _hoisted_9 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_10 = { align: "center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_12 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  YOUR GROUP ACCUMULATED PV", -1)
const _hoisted_14 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_15 = { align: "center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_17 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  YOUR TOTAL STAIR STEP EARNINGS", -1)
const _hoisted_19 = {
  class: "border border-gray-300 border-dashed rounded min-w-275px py-3 px-4 me-6 mb-3",
  align: "center"
}
const _hoisted_20 = { align: "center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_22 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  YOUR TOTAL STAIR STEP EARNINGS FOR THIS MONTH", -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-lg-4" }
const _hoisted_26 = { class: "row mt-5" }
const _hoisted_27 = { class: "col-lg-4 mb-3" }
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">January</option><option value=\"2\">February</option><option value=\"3\">March</option><option value=\"4\">April</option><option value=\"5\">May</option><option value=\"6\">June</option><option value=\"7\">July</option><option value=\"8\">August</option><option value=\"9\">September</option><option value=\"10\">October</option><option value=\"11\">November</option><option value=\"12\">December</option>", 12)
const _hoisted_41 = { class: "col-lg-2 text-center mb-1" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " View ", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_45 = { class: "col-lg-7" }
const _hoisted_46 = { class: "row col-lg-12" }
const _hoisted_47 = { class: "table-responsive" }
const _hoisted_48 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_49 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-70px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-250px" }, "Business Partners"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Personal PV"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Group PV"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px" }, "Commission")
  ])
], -1)
const _hoisted_50 = { class: "d-flex align-items-center" }
const _hoisted_51 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_52 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_53 = { class: "text-muted font-weight-bold d-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode("div", null, [
            _createVNode(_component_el_skeleton, {
              rows: 3,
              animated: ""
            })
          ], 512), [
            [_vShow, _ctx.loadingEarnings]
          ]),
          _withDirectives(_createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.totalPersonalPoints).toFixed(2))), 1)
              ]),
              _hoisted_8
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.totalGroupPoints).toFixed(2))), 1)
              ]),
              _hoisted_13
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.totalSstepCom).toFixed(2))), 1)
              ]),
              _hoisted_18
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode("div", _hoisted_22, _toDisplayString(_ctx.numberWithCommas(_ctx.totalSstepComThisMonth.toFixed(2))), 1)
              ]),
              _hoisted_23
            ])
          ], 512), [
            [_vShow, !_ctx.loadingEarnings]
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control form-control-lg form-control-solid mb-2",
                  placeholder: "year",
                  name: "year",
                  readonly: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.year = $event))
                }, null, 512), [
                  [_vModelText, _ctx.year]
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _withDirectives(_createVNode("select", {
                  class: "form-select form-select-solid form-select-lg fw-bold mb-2",
                  name: "month",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.month = $event))
                }, [
                  _hoisted_29
                ], 512), [
                  [_vModelSelect, _ctx.month]
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("button", {
                  type: "submit",
                  class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadSStep_summary()))
                }, [
                  _hoisted_42,
                  _hoisted_43
                ])
              ])
            ])
          ]),
          _hoisted_44,
          _createVNode("div", _hoisted_45, [
            _createVNode("div", _hoisted_46, [
              _createVNode("div", _hoisted_47, [
                _createVNode("table", _hoisted_48, [
                  _hoisted_49,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                      return (_openBlock(), _createBlock("tr", { key: index }, [
                        _createVNode("td", null, "      " + _toDisplayString(index + 1), 1),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_50, [
                            _createVNode("div", null, [
                              _createVNode("a", _hoisted_51, _toDisplayString(item.fullname.toUpperCase()), 1),
                              _createVNode("span", _hoisted_52, _toDisplayString(item.rusid.toUpperCase()), 1),
                              _createVNode("span", _hoisted_53, "Rank: " + _toDisplayString(item.rank.toUpperCase()), 1)
                            ])
                          ])
                        ]),
                        _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.psnPosPV)), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.grpPosPV)), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.totComPV)) + _toDisplayString(_ctx.getTotalTEST(item.totComPV, index)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_pagination, {
        pagination: _ctx.pagination,
        callback: _ctx.reorderhistory,
        options: _ctx.paginationOptions
      }, null, 8, ["pagination", "callback", "options"])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}